import { Box, Typography, Container } from "@mui/material";

const Home = () => {
  return (
    <Container 
      maxWidth="md" 
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        bgcolor: "#f5f5f5",
        p: 4
      }}
    >
      {/* Logo with proper scaling */}
      <Box 
        component="img" 
        src="/logo.png" 
        alt="Kreatorum Logo" 
        sx={{ width: 120, height: "auto", mb: 4, boxShadow: 3 }}
      />

      {/* Title */}
      <Typography variant="h3" fontWeight="bold" color="text.primary">
        Kreatorium
      </Typography>

      {/* Subtitle */}
      <Typography variant="h5" color="text.secondary" mt={2}>
        Promoting Culture & Creativity
      </Typography>

      {/* Message */}
      <Typography variant="body1" color="gray" mt={3}>
        Our website is coming soon. Stay tuned!
      </Typography>
    </Container>
  );
};

export default Home;
